import React from 'react';

import { Container, LoadingCircle } from './styles';

const LoadingAnimation: React.FC = () => {
  return (
    <Container>
      <LoadingCircle />
    </Container>
  );
};

export default LoadingAnimation;
